import axios from 'utils/axios';

export const createWorkShift = (doctorId: string, startTime: Date, endTime: Date) => {
  return axios.post(`/api/v1/workshifts`, {
    doctorId,
    startTime,
    endTime,
  });
};
